export default __webpack_public_path__ + "static/media/seven.068a5aa2.jpg";